<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/comSalesIndex/cRetailOrderList' }">{{
          $t("Retail business management center")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ path: '/comSalesIndex/cRetailOrderDetail' }"
          >{{ $t("Order details") }}</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ $t("Payment record") }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="main_container">
      <!-- 支付工具 -->
      <div class="pay_tool_wrap">
        <div class="pay_tool_tit">可以选择以下工具完成订单支付：</div>
        <div class="pay_tool_list flex-rowl" v-if="paytoolList.length > 0">
          <div
            class="pay_tool_item"
            v-for="(item, index) in paytoolList"
            :key="index"
          >
            <div class="tit">{{ item.settypeidstr }}</div>
            <div class="main_wrap flex-rowl">
              <div class="icon" v-if="item.settoolicon">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="item.settoolicon"
                  fit="cover"
                ></el-image>
              </div>
              <!-- settypeid 1=银行结算，2=数字支付工具结算 -->
              <div class="content" v-if="item.settypeid == 1">
                <p class="flex-rowl">
                  账户名：{{ item.accountname }}
                  <span
                    class="copy_box"
                    :data-clipboard-text="item.accountname"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                </p>
                <p class="b">开户行：{{ item.bankname }}</p>
                <p class="flex-rowl">
                  账号：{{ item.account
                  }}<span
                    class="copy_box"
                    :data-clipboard-text="item.account"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                </p>
              </div>
              <div class="content" v-if="item.settypeid == 2">
                <p class="b">结算工具名称：{{ item.settoolidstr }}</p>
                <p class="flex-rowl">
                  账号：{{ item.cusacc }}
                  <span
                    class="copy_box"
                    :data-clipboard-text="item.account"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 暂无数据 -->
        <div class="no_data" v-else>
          <p>暂无支付工具</p>
        </div>
      </div>

      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <div @click="handleDetail('')">
            <p class="flex-rowl">
              <i class="iconfont icon-xinzeng"></i>
              {{ $t("Add payment record") }}
            </p>
          </div>
        </div>
      </div>
      <div class="collect_wrap flex-rowl">
        <p>
          {{ $t("Amount paid") }}：( {{ USERINFO.countryExrateObj.moneyslog }} )
          {{ dataItem.totalpaynum_trans | formatPrice }}
        </p>
        <p>
          {{ $t("Amount to be settled") }}：(
          {{ USERINFO.countryExrateObj.moneyslog }} )
          {{ dataItem.totalremain_trans | formatPrice }}
        </p>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        :element-loading-text="$t('Please wait')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="(item, index) in dataList" :key="index">
            <div class="item_main_wrap flex-rowl">
              <div class="content_wrap flex-between">
                <div class="intro_box flex-rowl">
                  <!-- <div class="intro_box flex-rowl" @click="handleDetail(item.id)"> -->
                  <div class="block">
                    <p>
                      {{ $t("Payment number") }}：
                      <span>{{ item.logno }}</span>
                    </p>
                    <p>
                      {{ $t("Payment method") }}：
                      <span>{{
                        item.paytypestr == "银行转账"
                          ? $t("Bank transfer")
                          : item.paytypestr
                      }}</span>
                    </p>
                    <p>
                      {{ $t("Currency") }}：
                      <span>{{ item.currencystr }}</span>
                    </p>
                    <p>
                      {{ $t("Payment amount") }}：
                      <span
                        >( {{ USERINFO.countryExrateObj.moneyslog }} )
                        {{ item.paynum | formatPrice }}</span
                      >
                    </p>
                    <p>
                      {{ $t("Registration date") }}：
                      <span>{{ item.createdate | formatDate }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      {{ $t("Payer account name") }}：<span>{{
                        item.headname
                      }}</span>
                    </p>
                    <p>
                      {{ $t("Payer bank") }}：<span>{{ item.bankname }}</span>
                    </p>
                    <p>
                      {{ $t("Payer account number") }}：<span>{{
                        item.bankaccount
                      }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      {{ $t("Payment record audit status") }}：<span>{{
                        item.checkstate == "待审核"
                          ? $t("Pending review")
                          : item.checkstate == "已审核"
                          ? $t("Approved")
                          : item.checkstate == "审核驳回	"
                          ? $t("Failed the audit")
                          : ""
                      }}</span>
                    </p>
                    <p>
                      {{ $t("Rejection reason") }}：<span>{{
                        item.checkdetail ? item.checkdetail : $t("None")
                      }}</span>
                    </p>
                    <p>
                      {{ $t("Payment record application date") }}：<span>{{
                        item.checkdate | formatDate
                      }}</span>
                    </p>
                  </div>

                  <div class="block shop_last">
                    <div class="item">
                      <h1>{{ $t("Payment voucher screenshot") }}：</h1>
                    </div>
                    <div class="upload_list flex-rowl">
                      <div
                        class="upload_box"
                        v-for="(itemChild, indexChild) in item.picsList"
                        :key="indexChild"
                        @mouseenter="enter(index, indexChild)"
                        @mouseleave="leave(index, indexChild)"
                      >
                        <div class="upload_item">
                          <el-image
                            style="width: 100%; height: 100%"
                            :src="itemChild"
                            fit="cover"
                          ></el-image>
                        </div>
                        <div
                          class="el-upload-list__item-actions flex-rowc"
                          v-show="
                            creenIndex === index &&
                            creenChildIndex == indexChild
                          "
                          @click.stop="handlePictureCardPreview(itemChild)"
                        >
                          <span><i class="iconfont icon-fangda"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty :description="$t('NoData')" v-else></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->

    <!--  主要内容 end -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { encryptstringview, encryptstringadd } from "../../../api/api";
import { getOrderPayList, getOrderListDetail } from "../../../api/shop";
import {
  getQySettlementInfoList,
  getAreaSettlementInfo,
  getQyBaseInfo,
} from "../../../api/company";
import { mapState } from "vuex";
import Clipboard from "clipboard";
export default {
  name: "cPaymentPayList",
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      creenIndex: "",
      creenChildIndex: "",

      state: "", // sk=订单收款管理、sh=订单审核管理
      type: 1,
      dataList: [],
      loading: false,
      params: {
        orderno: "",
        pageindex: 1,
        pagesize: 10,
        keyword: "",
      },
      orderId: "",
      orderOpenid: "",
      listTotal: 0,

      dataItem: "", // 订单详情

      // 已付金额-越南盾
      totalpaynum_yn: 0,
      // 待结清金额-越南盾
      totalremain_yn: 0,

      // 结算工具
      paytoolList: [],
    };
  },
  computed: {
    ...mapState(["OPENID", "COUNTRY", "USERINFO"]),
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) return "0.00";
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { orderno, orderId, orderOpenid, state } = JSON.parse(res.jsondata);
        this.orderId = orderId;
        this.orderOpenid = orderOpenid;
        this.params.orderno = orderno;
        this.state = state;
        this.getOrderPayList();

        this.getOrderListDetail(orderId, orderOpenid);
      } else {
        this.$router.back();
      }
    },

    // 企业结算信息管理
    getQySettlementInfoList(qyid) {
      let params = {
        pageindex: 1,
        pagesize: 15,
        qyid,
        settypeid: "",
        accountstate: true, // 状态 "true","启用"|"false","停用"|
        setcountryids: this.USERINFO.countryid,
      };
      getQySettlementInfoList(params).then((res) => {
        this.paytoolList = res.list;
      });
    },

    // 地区结算信息管理
    getAreaSettlementInfo() {
      let params = {
        pageindex: 1,
        pagesize: 15,
        countryid: this.USERINFO.countryid,
        accountstate: 1, // 状态 =1=启用 0=停用
        settypeid: "",
        settoolid: "",
      };
      getAreaSettlementInfo(params).then((res) => {
        this.paytoolList = res.list;
      });
    },

    // 获取企业基本信息
    getQyBaseInfo(qyid) {
      getQyBaseInfo({ qyid }).then((res) => {
        /**
         * 是否允许独立结算isdu 是  否
         * 1、如果允许独立结算，则获取企业结算信息
         * 2、如果不允许独立结算，则获取地区结算信息
         */
        if (res.isdu == "是") {
          this.getQySettlementInfoList(qyid);
        } else {
          this.getAreaSettlementInfo();
        }
      });
    },

    // 分页
    handleCurrentChange(e) {
      this.params.pageindex = e;
      this.getOrderPayList();
    },

    // 重置数据
    handleRest() {
      this.params.pageindex = 1;
      this.params.keyword = "";
      this.getOrderPayList();
    },

    // 获取数据
    getOrderPayList() {
      this.loading = true;
      getOrderPayList(this.params).then((res) => {
        res.list.sort((a, b) => b.createdate.localeCompare(a.createdate));
        res.list.forEach((v) => {
          v.picsList = v.shotcut ? v.shotcut.split(",") : [];
        });
        this.dataList = res.list;
        this.listTotal = res.total;
        this.loading = false;
      });
    },

    // 订单列表
    getOrderListDetail(id, openid) {
      let params = {
        openid: openid,
        orderid: id,
      };
      getOrderListDetail(params).then((res) => {
        let newObj = res[0];
        this.dataItem = newObj;
        this.getQyBaseInfo(newObj.qyid);
      });
    },

    handleDetail(id) {
      let { orderId, orderOpenid } = this;
      if (id) {
        this.encryptstringadd("cPaymentPayDetail", {
          orderId,
          orderOpenid,
          id,
        });
        // this.$router.push({ path: "/brandIndex/brandDetail", query: { id } });
      } else {
        this.encryptstringadd("cPaymentPayDetail", {
          orderId,
          orderOpenid,
          id: "",
        });
      }
    },
    // 大图预览
    handlePictureCardPreview(item) {
      this.dialogImageUrl = item;
      this.dialogVisible = true;
    },
    // 移入图片区域
    enter(index, indexChild) {
      this.creenIndex = index;
      this.creenChildIndex = indexChild;
    },
    leave() {
      this.creenIndex = "";
      this.creenChildIndex = "";
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$message.success(this.$t("Copy successful"));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$message.warning("SAO chép không thành công");
        } else {
          // this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .pay_tool_wrap {
    margin: 10px 0 0;
    .pay_tool_tit {
      font-size: 20px;
      color: #333333;
      margin-bottom: 16px;
    }
    .pay_tool_list {
      flex-wrap: wrap;
      .pay_tool_item {
        padding: 15px 25px;
        box-sizing: border-box;
        border: 2px dashed #1d2088;
        border-radius: 30px;
        cursor: pointer;
        margin-right: 20px;
        margin-bottom: 15px;
        &:last-child {
          margin-right: 0;
        }
        .tit {
          font-size: 18px;
          color: #292929;
          font-weight: bold;
          margin-bottom: 5px;
        }
        .main_wrap {
          .icon {
            width: 100px;
            height: 100px;
            border-radius: 15px;
            overflow: hidden;
            margin-right: 12px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .content {
            font-size: 16px;
            color: #000000;
            p {
              margin-bottom: 8px;
              &.b {
                font-weight: bold;
              }
              &:last-child {
                margin-bottom: 0;
              }
              .copy_box {
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }
  .operation_wrap {
    .screen_wrap {
      font-size: 14px;
      .sort_wrap {
        border: 1px solid #d8d8d8;
        border-radius: 20px;
        height: 35px;
        padding: 0 10px;
        margin-right: 10px;
      }
      .select_wrap {
        margin-right: 10px;
      }
      .icon-24gl-swapHorizontal {
        transform: rotate(90deg);
      }
    }
  }
  .collect_wrap {
    margin-bottom: 20px;
    font-size: 16px;
    color: #ff0036;
    p {
      margin-right: 30px;
    }
  }
  .list_wrap {
    height: 53vh;
    overflow-y: scroll;
    .item_main_wrap {
      .address_wrap {
        width: 28%;
      }
      .customer_wrap {
        span {
          height: 40px;
          border: 1px solid #d2d2d2;
          font-size: 12px;
          padding: 0 10px;
          margin-right: 5px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .intro_box {
        // cursor: pointer;
        .block {
          width: 22%;
        }
        .shop_last {
          flex-shrink: 0;
          width: 31%;
          margin-left: 30px;
          .item {
            margin-bottom: 10px;
          }
          .upload_list {
            flex-wrap: wrap;
            .upload_box {
              width: calc((100% - 25px) / 4);
              height: 100px;
              margin-right: 5px;
              margin-bottom: 10px;
              border: 1px dashed #c0ccda;
              border-radius: 5px;
              cursor: pointer;
              position: relative;
              &:nth-child(4n) {
                margin-right: 0;
              }
              .upload_item {
                height: 100%;
                width: 100%;
                position: relative;
                img {
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%, -50%);
                }
              }
              .custom-upload {
                .el-upload--picture-card {
                  // width: 120px;
                  // height: 120px;
                }
              }
              .el-upload-list__item-actions span {
                &:last-child {
                  margin-left: 0;
                }
              }

              &:last-child {
                margin-right: 0;
              }
            }
            .custom_upload {
              background-color: #fbfdff;
              border: 1px dashed #c0ccda;
              border-radius: 6px;
              box-sizing: border-box;
              width: 148px;
              height: 148px;
              cursor: pointer;
              line-height: 146px;
              vertical-align: top;
              cursor: pointer;
              input {
                opacity: 0;
                width: 100%;
                height: 100%;
                position: relative;
                z-index: 10;
                cursor: pointer;
              }
              .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                z-index: 9;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            }
          }
        }
      }
    }
    .red {
      color: #ff0036;
    }
  }
}
</style>